import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLoyaltyInvite } from '../../../redux/buzzbridgeLoyalty/actions';
import { loyaltyInviteLoadingSelector, loyaltyInviteSelector } from '../../../redux/buzzbridgeLoyalty/selectors';
import type { RootState } from '../../../redux/root-reducer';
import { useDispatchPromise } from '../../../utils/AppUtils';

/** Loads invite/referral link once — only when the user is signed in. */
export function useBuzzbridgeLoyaltyInvite() {
    const dispatchPromise = useDispatchPromise();
    const invite = useSelector(loyaltyInviteSelector);
    const fetching = useSelector(loyaltyInviteLoadingSelector);
    const isLoggedIn = useSelector((state: RootState) => Boolean(state.authentication.isLoggedIn));

    useEffect(() => {
        if (!isLoggedIn || invite || fetching) return;
        void dispatchPromise(getLoyaltyInvite());
    }, [dispatchPromise, invite, fetching, isLoggedIn]);

    return { invite: isLoggedIn ? invite : undefined, loading: isLoggedIn && fetching && !invite };
}
